import React from 'react'
import { Checkbox, Dropdown, TextField } from 'office-ui-fabric-react'
import {
  ExperimentParameter,
  ExperimentTypeParameter,
} from '../../Api/experiments'
import { NumberInput } from '../../Components/Input/NumberInput'
import InfoBox from '../CampaignCollectionScreen/CampaignDialog/InfoBox'

interface Error {
  field: string
  message: string
}

export function CreateOrManageExperimentParameters({
  disabled,
  errors,
  parametersDefinition,
  parameters,
  onChange,
}: {
  disabled: boolean
  errors: Error[]
  parametersDefinition: ExperimentTypeParameter[]
  parameters: ExperimentParameter[]
  onChange: (parameters: ExperimentParameter[]) => void
}) {
  const onInputChange = ({
    parameterDefinition,
    value,
  }: {
    parameterDefinition: ExperimentTypeParameter
    value: any
  }) => {
    const newParameters = parameters.map((p) =>
      p.name === parameterDefinition.name ? { ...p, value } : p
    )
    onChange(newParameters)
  }
  return (
    <>
      {parametersDefinition.map((parameterDefinition) => {
        const parameter = parameters.find(
          (parameter) => parameter.name === parameterDefinition.name
        )
        return (
          <>
            <ExperimentParameterInput
              key={parameterDefinition.name}
              parameterDefinition={parameterDefinition}
              parameter={parameter}
              disabled={disabled}
              error={getErrorMessage(errors, parameterDefinition.name)}
              onChange={(value) =>
                onInputChange({ parameterDefinition, value })
              }
            />
            {parameterDefinition.note ? (
              <InfoBox>{parameterDefinition.note}</InfoBox>
            ) : null}
          </>
        )
      })}
    </>
  )
}

function ExperimentParameterInput({
  parameterDefinition,
  parameter,
  disabled,
  error,
  onChange,
}: {
  parameterDefinition: ExperimentTypeParameter
  parameter?: ExperimentParameter
  disabled: boolean
  error?: string
  onChange: (value: any) => void
}) {
  switch (parameterDefinition.type) {
    case 'choice': {
      return (
        <Dropdown
          placeholder="Select an option"
          label={parameterDefinition.label}
          disabled={disabled}
          required={parameterDefinition.required}
          selectedKey={parameter ? parameter.value : undefined}
          options={parameterDefinition.choices.map(({ label, value }) => ({
            key: value,
            text: label,
          }))}
          errorMessage={error}
          onChange={(_event, item): void => {
            onChange(item ? item.key : undefined)
          }}
        />
      )
    }
    case 'boolean': {
      return (
        <Checkbox
          label={parameterDefinition.label}
          disabled={disabled}
          value={parameter ? parameter.value : false}
          checked={parameter ? parameter.value : false}
          onChange={(_event, value): void => {
            onChange(!!value)
          }}
        />
      )
    }
    case 'number': {
      return (
        <NumberInput
          label={parameterDefinition.label}
          disabled={disabled}
          required={parameterDefinition.required}
          value={parameter && parameter.value != null ? parameter.value : null}
          onChange={(value?: number) => {
            onChange(value || null)
          }}
          errorMessage={error}
          precision={2}
        />
      )
    }
    case 'string': {
      return (
        <TextField
          label={parameterDefinition.label}
          disabled={disabled}
          required={parameterDefinition.required}
          value={parameter ? parameter.value : ''}
          onChange={(_event, newValue): void => {
            onChange(
              newValue !== undefined && newValue !== null ? newValue : ''
            )
          }}
          errorMessage={error}
        />
      )
    }
    default: {
      return null
    }
  }
}

function getErrorMessage(errors: Error[], field: string) {
  const isSameField = (error: Error) => error.field === field
  const error = errors.find(isSameField)
  return error ? error.message : ''
}
